module.exports = __webpack_public_path__ + "img/e_3_1_g.85faf1ab.png";